import React from "react";

export const Overview = () => {
  return (
    <div className="flex items-center justify-between p-4 bg-[#F6F7F9] font-MTNfont">
      <div>
        <h1 className="font-sans text-xl font-bold">Inbox</h1>
      </div>
    </div>
  );
};
